import React from "react";

const CheckboxTick = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect width="20" height="20" rx="5" fill="#604BE8" />
      <path
        d="M14.6666 6.5L8.24992 12.9167L5.33325 10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckboxTick;
